"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incidentTypesDetails = void 0;
exports.incidentTypesDetails = [
    { code: 'TO_CANCEL', label: 'À annuler' },
    { code: 'OUTSOURCING', label: 'Sous-traitance' },
    { code: 'TO_DISPATCH', label: 'À dispatcher' },
    { code: 'ASK_CALL', label: 'Demande de rappel' },
    { code: 'CUSTOMER_CLAIM', label: 'Réclamation client' },
    { code: 'CHECKOUT_ERROR', label: 'Incident de checkout' },
    { code: 'OVERLAPPING_TRIP', label: 'Chevauchements de courses' },
    { code: 'CHECK_DATA', label: 'Contrôle des infos de la course' },
    { code: 'DOUBLON', label: 'Doublon' },
    { code: 'PASSENGER_ASK_CALL', label: 'Demande de rappel passager' },
    { code: 'NO_DROP_OFF', label: 'Pas de dépose' },
    { code: 'CANCELLATION_IN_DEDICATED_PAKCAGE', label: 'Optimisation forfait dédié' },
    { code: 'NO_SHOW_REQUEST', label: 'Demande de no show' },
    { code: 'NO_APPROACH', label: 'Approche tardive' },
    { code: 'DRIVER_LATE', label: 'Retard Chauffeur' },
    { code: 'DRIVER_CLAIM', label: 'Réclamation chauffeur' },
    { code: 'TEXT_MESSAGE_RECEIVED', label: 'Nouveau message' },
    { code: 'NO_PICK_UP', label: 'Pas de prise en charge' },
    { code: 'DRIVER_TO_SUSPEND', label: 'Demande de suspension chauffeur' },
];
